<template>
  <div>
    <v-dialog
      max-width="600px"
      min-width="360px"
      content-class="dialogcss"
      Modal
      persistent
      v-model="isDialog"
      v-if="isDialog == true"
    >
      <v-card>
        <v-card-title class="headline">{{ $t("common.login") }}</v-card-title>
        <v-card-title class="cancel" @click.stop="isDialog = false"
          >x</v-card-title
        >
        <v-card-text>
          <div id="login-container-1"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <button
      class="customStartButton"
      v-if="state.profile.isSigned"
      @click="dashboard()"
    >
      {{ $t("base.dashboardText") }}
    </button>
    <button
      class="customStartButton"
      v-if="!state.profile.isSigned"
      @click="startLogin()"
    >
      {{ $t("landingPage.section1.text3") }}
    </button>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import router from "../router/router";
import { setLocale, ui } from "../services/firebase";

export default {
  name: "StartBtn",
  props: [],
  mounted() {
    setLocale();
  },
  data() {
    return {
      isDialog: false,
    };
  },
  methods: {
    dashboard: function() {
      router.push("/admin");
    },
    startLogin: function() {
      this.isDialog = true;
      this.$store.dispatch("startLogin");
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
  },
};
</script>
